import { CourseMappingsProvider } from './context';
import { useCourseMappingsPageProps } from './data/useCourseMappingsPageProps';
import { CourseMappingsLayout } from './layouts';
import { LoadingPage } from '~/pages/LoadingPage';
import { ErrorPage, ErrorHandler } from '~/pages/ErrorPage';
import { useWindowDocumentTitle } from '~/lib/useWindowDocumentTitle';

export function CourseMappingsPage() {
  useWindowDocumentTitle('Course Mappings');
  const { initialProps, isLoadingInitialProps, isInitialPropsError, initialPropsError } = useCourseMappingsPageProps();

  if (!isInitialPropsError && isLoadingInitialProps) {
    return <LoadingPage />;
  }
  if (isInitialPropsError) {
    return <ErrorHandler error={initialPropsError} />;
  }
  if (!initialProps) {
    return <ErrorPage customMessage="Failed to fetch page props." />;
  }

  return (
    <CourseMappingsProvider initialProps={initialProps}>
      <CourseMappingsLayout />
    </CourseMappingsProvider>
  );
}
